
import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import DokumanTuruPicker from "@/components/pickers/DokumanTuruPicker.vue";
import { FileEntity } from "@/entity/FileEntity";

@Component({
  components: { DokumanTuruPicker, FormWrapper }
})
export default class DokumanForm extends Mixins(ObjectInputMixin) {
  @Prop({ required: true }) action!: string;
  @Prop() turAction!: string;

  @Ref("dokumanTuruPicker") readonly dokumanTuruPicker!: DokumanTuruPicker;
  @Ref("formWrapper") formWrapper!: FormWrapper;

  // v-model
  localValue!: FileEntity & {
    manuel_dokuman_turu?: string;
    xml_yansit?: boolean;
    dosya?: File;
    aciklama?: string;
    dokuman_turu_id?: number | string;
  };

  created() {
    // checkbox default
    if (this.localValue && this.localValue.xml_yansit == null) {
      // @ts-ignore
      this.$set(this.localValue, "xml_yansit", false);
    }
  }

  fileRule() {
    const f: any = (this.localValue || {}).dosya;
    if (!f) return "Lütfen bu alanı doldurun.";
    const ext = String(f.name).split(".").pop();
    const ok = ["udf","pdf","jpg","jpeg","png","tif","tiff","UDF","PDF","JPG","JPEG","PNG","TIF","TIFF"].includes(ext || "");
    if (!ok) return "Doküman formatı UYAP'a uygun değil.";
    if (f.size < 10485760) return true;
    return "Doküman boyutu 10MB'dan fazla olamaz.";
  }

  onClose() {
    this.$emit("onClose");
  }

  /** dataURL -> sha1 hex */
  private async sha1HexFromBase64DataUrl(dataUrl: string): Promise<string> {
    const base64 = dataUrl.split(",")[1] || "";
    const bin = atob(base64);
    const buf = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
    const digest = await crypto.subtle.digest("SHA-1", buf);
    return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, "0")).join("");
  }

  async save() {
    this.formWrapper.onFly = true;
    try {
      const formData = new FormData();
      const file: any = this.localValue.dosya;

      // hash
      const b64 = await this.$helper.convertToBase64(file);
      const hashHex = await this.sha1HexFromBase64DataUrl(b64);

      formData.append("aciklama", this.localValue.aciklama ?? "");
      formData.append("file", file);
      formData.append("dokuman_turu_id", String(this.localValue.dokuman_turu_id));
      formData.append("hash", hashHex);

      // Diğer seçildiyse ek alanlar
      if (Number(this.localValue.dokuman_turu_id) === 10) {
        formData.append("manuel_dokuman_turu", this.localValue.manuel_dokuman_turu || "");
        formData.append("xml_yansit", this.localValue.xml_yansit ? "1" : "0"); // backend alan adı farklıysa değiştirin
      }

      await this.$http.post(this.action + "/file", formData);
      this.$emit("onSuccess");

      // temizlik
      if (Number(this.localValue.dokuman_turu_id) === 10) {
        this.localValue.manuel_dokuman_turu = "";
        this.localValue.xml_yansit = false;
      }
    } finally {
      this.formWrapper.onFly = false;
    }
  }
}
